import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { element } from 'protractor';

@Component({
  selector: 'app-branch-auth',
  templateUrl: './branch-auth.component.html',
  styleUrls: ['./branch-auth.component.css']
})
export class BranchAuthComponent implements OnInit {

  model = { 'table_name': 'branch_auth', 'branch_auth_id': '0', 'user_id': '', 'branch_id': '', 
    'store_id': '0', 'comment': '' };

  private dp = [];

  public name = '';
  public user_name = '';
  user_id;
  auth_detail = [];
  // delete_list = [];

  displayedColumns = ['branch_name', 'store_name', 'choose_store'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  Success_Msg; Error_Msg; Select_Branch_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<BranchAuthComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Select_Branch_Msg').subscribe((res: string) => {
      this.Select_Branch_Msg = res;
    });
  }

  ngOnInit() {

    if (this.dialog_data != null) {
      this.name = this.dialog_data['1']['name'];
      this.user_name = this.dialog_data['0']['user_name'];
      this.user_id = this.dialog_data['0']['user_id'];

      let query = "SELECT `branch`.*, `store`.* FROM `branch`, `store` WHERE `branch`.`status` = '1'" +
        " AND `store`.`status` = '1' AND `store`.`branch_id` = `branch`.`branch_id` ORDER BY `branch`.`branch_id`";
      let obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.dp = data.data['list'];
          let all_store = true;

          //get the saved authorities if exist:
          query = "SELECT * FROM `branch_auth` WHERE `status` = '1' AND `user_id` ='" + this.user_id + "'";
          obj = { cmd: 'getList', query: query };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              this.auth_detail = data.data['list'];

              this.dp.forEach(element => {
                // element.flag = 'new';
                element.branch_auth_id = '0';
                element.store_choosed = '0';

                this.auth_detail.forEach(auth_element => {
                  if (element.store_id == auth_element.store_id) {
                    // element.flag = 'update';
                    element.branch_auth_id = auth_element.branch_auth_id;
                    element.store_choosed = '1';

                    return false;
                  }
                });
                
                if (element.branch_auth_id == '0')
                  all_store = false;
              });
              this.dataSource = new MatTableDataSource(this.dp);
              this.dataSource.sort = this.sort;

              (document.getElementById('store_auth') as HTMLInputElement).checked = all_store;
            });
        });
    }
  }

  choose_one_auth(row) {

    let all_store = true;
    let choose_store = document.getElementById('choose_store_' + row.store_id) as HTMLInputElement;

    if (!choose_store.checked) 
      all_store = false;
    else {
      this.dp.forEach(element => {
        choose_store = document.getElementById('choose_store_' + element.store_id) as HTMLInputElement;
        if (!choose_store.checked) {
          all_store = false;
          return false;
        }
      });
    }
    
    (document.getElementById('store_auth') as HTMLInputElement).checked = all_store;

    // if (type == 'branch') {
    //   let all_branch = true;
    //change the value of the selected branch:
    // this.branch_list.forEach(element => {
    //   let choose_branch = document.getElementById('choose_branch_' + element.branch_id) as HTMLInputElement;
    //   if (id == element.branch_id) {
    //     element.branch_choosed = (choose_branch.checked ? '1' : '0');

    //     if (mode == 'update') {
    //       if (element.branch_choosed == '0') {
    //         element.flag = 'delete';
    //         element.branch_auth_id = branch_auth_id;
    //         this.delete_list.push(element);
    //       }
    //       else {
    //         element.flag = 'update';
    //         element.branch_auth_id = branch_auth_id;
    //       }
    //     }
    //   }

    //   if (!choose_branch.checked)
    //     all_branch = false;
    // });

    //check select all if all branches are selected:
    //   if (all_branch == true)
    //     (document.getElementById('branch_auth') as HTMLInputElement).checked = true;
    //   else
    //     (document.getElementById('branch_auth') as HTMLInputElement).checked = false;
    // }

    // if (type == 'store') {
    //   let all_store = true;
    //   //change the value of the selected store:
    //   this.dp.forEach(element => {
    //     let choose_store = document.getElementById('choose_store_' + element.store_id) as HTMLInputElement;
    //     if (id == element.store_id) {
    //       element.store_choosed = (choose_store.checked ? '1' : '0');

    //       if (mode == 'update' && !choose_store.checked) {
    //         element.flag = 'delete';
    //         this.delete_list.push(element);
    //         element.branch_auth_id = branch_auth_id;
    //       }

    //       else if (mode == 'update' && choose_store.checked) {
    //         element.flag = 'update';
    //         element.branch_auth_id = branch_auth_id;
    //       }
    //     }
    //     if (!choose_store.checked)
    //       all_store = false;

    //   });

      //check select all if all stores are selected:
      // (document.getElementById('store_auth') as HTMLInputElement).checked = all_store;
      // if (all_store == true)
      //   (document.getElementById('store_auth') as HTMLInputElement).checked = true;
      // else
      //   (document.getElementById('store_auth') as HTMLInputElement).checked = false;
    // }
  }

  // get_store(branch_id) {
  //get all stores list:
  // let query = "SELECT * FROM `store` WHERE `status` = '1' AND `branch_id` ='" + branch_id + "'";
  // let obj = { cmd: 'getList', query: query };
  // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
  //   .subscribe(data => {
  //     this.applicationConstants.appComp.hideBusyCursor();
  //     this.store_list = data.data['list'];
  //     this.store_list.forEach(element => {
  //       element.store_choosed = '0';
  //       element.flag = 'new';
  //       element.branch_auth_id = '0';
  //     });

  //     //select the existed authorities:
  //     this.auth_detail.forEach(element => {
  //       this.store_list.forEach(store => {
  //         if (element.store_id == store.store_id) {
  //           store.store_choosed = '1';
  //         }
  //       });
  //     });

  //     this.dataSource1 = new MatTableDataSource(this.store_list);
  //     this.dataSource1.sort = this.sort;
  //   });
  // }

  all_auth(type) {
    let store_auth = (document.getElementById('store_auth') as HTMLInputElement);

    this.dp.forEach(element => {
      (document.getElementById('choose_store_' + element.store_id) as HTMLInputElement).checked = store_auth.checked;
      element.store_choosed = (store_auth.checked ? '1' : '0');
    });

    //select all branches:
    // if (type == 'branch') {
    //   let branch_auth = (document.getElementById('branch_auth') as HTMLInputElement);

    // this.branch_list.forEach(element => {

    //   //change the value of the selected branch:
    //   if (branch_auth.checked)
    //     (document.getElementById('choose_branch_' + element.branch_id) as HTMLInputElement).checked = true;
    //   else
    //     (document.getElementById('choose_branch_' + element.branch_id) as HTMLInputElement).checked = false;

    //   element.branch_choosed = ((document.getElementById('choose_branch_' + element.branch_id) as HTMLInputElement).checked ? '1' : '0');

    // });
    // }

    //select all stores:
    // if (type == 'store') {
    //   let store_auth = (document.getElementById('store_auth') as HTMLInputElement);

    //   this.dp.forEach(element => {

    //     //change the value of the selected store:
    //     if (store_auth.checked) {
    //       (document.getElementById('choose_store_' + element.store_id) as HTMLInputElement).checked = true;
    //     }
    //     else {
    //       (document.getElementById('choose_store_' + element.store_id) as HTMLInputElement).checked = false;
    //       if (element.flag == 'update') {
    //         element.flag = 'delete';
    //         this.delete_list.push(element);
    //         //element.branch_auth_id = branch_auth_id;
    //       }
    //     }

    //     element.store_choosed = ((document.getElementById('choose_store_' + element.store_id) as HTMLInputElement).checked ? '1' : '0');
    //   });
    // }
  }

  add() {
    
    let values = [];

    this.dp.forEach(element => {
      let choose_store = document.getElementById('choose_store_' + element.store_id) as HTMLInputElement;

      if (choose_store.checked) {
        values.push({
          'table_name': 'branch_auth', 'branch_auth_id': element.branch_auth_id, 'user_id': this.user_id,
          'key': 'branch_auth_id', 'flag': (element.branch_auth_id == '0' ? 'new' : 'update'), 
          'branch_id': element.branch_id, 'store_id': element.store_id, 'comment': ''
        });
      }
      else {
        if (element.branch_auth_id != '0') {
          values.push({
            'table_name': 'branch_auth', 'branch_auth_id': element.branch_auth_id,
            'key': 'branch_auth_id', 'flag': 'delete', 'branch_id': element.branch_id
          });
        }
      }
    });

    // if (store_exist == false) {
    //   values.push({
    //     'table_name': 'branch_auth', 'branch_auth_id': '0', 'user_id': this.user_id,
    //     'key': 'branch_auth_id', 'flag': branch.flag, 'branch_id': branch.branch_id,
    //     'store_id': '0', 'comment': ''
    //   });
    // }
    //    }
    // });

    // this.delete_list.forEach(element => {
    //   values.push({
    //     'table_name': 'branch_auth', 'branch_auth_id': element.branch_auth_id,
    //     'key': 'branch_auth_id', 'flag': element.flag, 'branch_id': element.branch_id,
    //   });
    // });

    console.log(values);

    let obj;
    // obj = { cmd: 'add', values: values };
    obj = { cmd: 'updateAdv', values: values };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.dialog_data = { 'op_type': 'success' };
          this.dialogRef.close(this.dialog_data);
        }
        else {
          alert(this.Error_Msg);
        }
      });

  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }


}
